import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import css from './index.scss';
import { hideToast } from './toast-action';

function Toast() {
  const dispatch = useDispatch();
  const isToastVisible = useSelector(
    (state) => state.toastReducer.isToastVisible
  );
  const message = useSelector((state) => state.toastReducer.message);
  const messageType = useSelector((state) => state.toastReducer.messageType);
  const timeout = useRef(null);

  function cleanup() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }

  useEffect(() => {
    const startTimer = () => {
      if (isToastVisible && timeout.current) {
        dispatch(hideToast());
        clearTimeout(timeout.current);
      }
    };

    timeout.current = setTimeout(startTimer, 7000);
    return () => cleanup();
  }, [isToastVisible, dispatch]);

  const hide = () => {
    dispatch(hideToast());
    cleanup();
  };

  const setToastColor = () => {
    let color = '';
    switch (messageType) {
      case 'success':
        color = '#5cb85c';
        break;
      case 'warning':
        color = '#e07e02';
        break;
      default:
        color = '#c53902';
        break;
    }

    return color;
  };

  if (isToastVisible) {
    return (
      <div className={css.toast} style={{ background: setToastColor() }}>
        <div className={css.message} onClick={hide} role="button" tabIndex={0}>
          {message}
        </div>
      </div>
    );
  }
  return <div className={css.empty} />;
}
export default Toast;



// WEBPACK FOOTER //
// ./components/toast/index.js